/*
 * @Date: 2020-07-08 17:22:23
 * @Author: lyb
 * @LastEditors: lyb
 * @LastEditTime: 2020-09-15 13:55:53
 */
import { getEnv, getBaseUrl } from './config.js'


const definedGlobalConst = (varName, value) => {
    Object.defineProperty(window, varName, {
        get() {
            return value
        },

        set() {
            throw new Error('不可修改全局const变量')
        }
    })
}

// 默认上传url
definedGlobalConst('baseUploadApi', `https://${getEnv()}apigateway.gaodun.com/base/v1/upload/upload`)
definedGlobalConst('baseOlafUrl', `${getBaseUrl()}apigateway.gaodun.com/olaf`)



// WEBPACK FOOTER //
// ./src/js/util/globalVaiable.js